export default {
	state: () => ({
		globalSpinnerIsShown: false,
		globalLoginExpiredModalIsEnabled: false,
		globalLoginExpiredModalIsShown: false,
		isNavigateToGatedSubSiteModalOpen: false,
	}),
	mutations: {
		setGlobalSpinnerIsShown: (state, isShown) => {
			state.globalSpinnerIsShown = isShown;
		},

		setGlobalLoginExpiredModalIsShown: (state, isShown) => {
			state.globalLoginExpiredModalIsShown = isShown;
		},

		setGlobalLoginExpiredModalIsEnabled: (state, isEnabled) => {
			state.globalLoginExpiredModalIsEnabled = isEnabled;
		},
		setIsNavigateToGatedSubSiteModalOpen: (state, isShown) => {
			state.isNavigateToGatedSubSiteModalOpen = isShown;
		},
	},
	getters: {
		getGlobalShowSpinner: (state) => {
			return state.globalSpinnerIsShown;
		},

		getGlobalLoginExpiredModalIsShown: (state) => {
			return state.globalLoginExpiredModalIsShown;
		},
		getIsNavigateToGatedSubSiteModalOpen: (state) => {
			return state.isNavigateToGatedSubSiteModalOpen;
		},
	},
	actions: {
		showGlobalSpinner: ({ commit }) => {
			commit('setGlobalSpinnerIsShown', true);
		},
		hideGlobalSpinner: ({ commit }) => {
			commit('setGlobalSpinnerIsShown', false);
		},

		showGlobalLoginExpiredModal: ({ commit }) => {
			commit('setGlobalLoginExpiredModalIsShown', true);
		},
		hideGlobalLoginExpiredModal: ({ commit }) => {
			commit('setGlobalLoginExpiredModalIsShown', false);
		},

		enableGlobalLoginExpiredModal: ({ commit }) => {
			commit('setGlobalLoginExpiredModalIsEnabled', true);
		},
		disableGlobalLoginExpiredModal: ({ commit }) => {
			commit('setGlobalLoginExpiredModalIsEnabled', false);
		},
		showNavigateToGatedSubSiteModal: ({ commit }) => {
			commit('setIsNavigateToGatedSubSiteModalOpen', true);
		},
		hideNavigateToGatedSubSiteModal: ({ commit }) => {
			commit('setIsNavigateToGatedSubSiteModalOpen', false);
		},
	},
};
